import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["switch", { checked: _ctx.inverse ? !_ctx.localValue : _ctx.localValue, monocolor: _ctx.monocolor }]),
    onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.toggle && _ctx.toggle(...args)))
  }, [
    _createElementVNode("span", {
      class: _normalizeClass(["slider round", { readonly: _ctx.readonly }])
    }, null, 2)
  ], 2))
}